import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from './FormProps';

interface FormPassword extends Omit<FormItemProps, 'multiple'> {
  autoComplete?: string;
}

const FormPassword = ({
  name,
  label,
  placeholder,
  rules,
  autoComplete,
  disabled,
  onChange,
  className,
  noStyle,
  ...props
}: FormPassword): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  return (
    <Form.Item
      label={t(label)}
      {...(rules && { rules })}
      {...(name && { name })}
      className={className}
      noStyle={noStyle}
    >
      <Input
        placeholder={t(placeholder)}
        disabled={disabled}
        type="password"
        onChange={onChange}
        {...(autoComplete ? { autoComplete } : {})}
        {...props}
      />
    </Form.Item>
  );
};

export default FormPassword;
